import React from 'react';
import { TopSeller } from '~/types/topSellersTypes';
import { useTranslation } from 'react-i18next';

const TopSellersCard = React.memo(({ topSeller }: { topSeller: TopSeller }) => {
  const { t, i18n } = useTranslation('app');
  const locale = i18n.language;

  return (
    <a
      href={`${process.env.REACT_APP_BASE_URL}/${locale}/user/${topSeller.id}`}
      target="_blank"
      rel="noopener noreferrer"
      className="relative flex items-center mb-4 h-[72px] bg-white rounded-[10px] cursor-pointer w-full"
    >
      <div className="flex items-center h-full relative w-full">
        {topSeller.user.logo ? (
          <img
            src={topSeller.user.logo.thumbnails.logo}
            alt="company-img"
            width={72}
            height={72}
            className="object-cover h-full rounded-[10px] border border-gray hover:border-blue transition-all duration-200 shrink-0"
          />
        ) : (
          <div className="w-[72px] h-[72px]  bg-gray_light_1 rounded-[10px] element-center  border border-gray hover:border-blue transition-all duration-200">
            <div className="w-[16px] h-[16px] flex element-center">
              <i
                className="inline-block bg-cover gallery-icon"
                style={{ width: '16px', height: '16px' }}
              />
            </div>
          </div>
        )}
        <div className="px-1.5x h-full flex justify-center flex-col overflow-hidden">
          <p className="font-[700] text-black truncate text-link">
            {topSeller.user.full_name}
          </p>
          <p className="font-normal flex text-gray__dark_1 gap-0.5x items-center text-body_2">
            {topSeller.numberOfActiveListing}
            <span>{t('listings')}</span>
          </p>
        </div>
      </div>
    </a>
  );
});

export default TopSellersCard;
